import { render, staticRenderFns } from "./reviewForm.vue?vue&type=template&id=7969e7d6&"
import script from "./reviewForm.vue?vue&type=script&lang=js&"
export * from "./reviewForm.vue?vue&type=script&lang=js&"
import style0 from "./reviewForm.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports